import { gql } from "@apollo/client";

export const createMallEntry = `
mutation CreateMallEntry($input: MallEntryInput!) {
  createMallEntry(input: $input) {
    success
    message
  }
}

`;
export const updatemall = `

mutation UpdateMall($id: ID!, $input: MallEntryInput!) { 

  updateMallEntry(id: $id, input: $input) { 

    success 

    message 

   

  } 

} 


`;
export const deletemall = `
mutation DeleteMallEntry($id: ID!) {
  deleteMallEntry(id: $id) {
    success
    message
  }
}


`;

export const bulkUploadMallEntry = gql`
  mutation BulkUploadMallEntry($file: Upload!) {
    bulkUploadMallEntry(file: $file) {
      success
      message
    }
  }
`;

export const createreconcilation = gql`
  mutation SubmitReconciliation($input: ReconciliationInput!) {
    submitReconciliation(input: $input) {
      success
      message
    }
  }
`;

export const createremark = gql`
  mutation SubmitRemark($input: RemarkInput!) {
    submitRemark(input: $input) {
      success
      message
    }
  }
`;

export const updateremark = `
mutation UpdateRemarkStatus($input: UpdateRemarkStatusInput!) {
    UpdateRemarkStatus(input: $input) {
      success
      message
    }
  }
`;
